import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type StoreService from 'scaleflow/services/store';
import type IntlService from 'ember-intl/services/intl';
import type AgentModel from 'scaleflow/models/agent';

export default class SettingsAgentsListController extends Controller {
  @service declare store: StoreService;
  @service declare intl: IntlService;

  queryParams = ['search'];
  @tracked search = '';

  get agents() {
    let agents = this.model as AgentModel[];

    if (this.search) {
      agents = agents.filter((agent: AgentModel) => {
        return (agent.name ?? '')
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    }

    return agents;
  }

  @action
  deleteAgent(agent: AgentModel) {
    void agent.destroyRecord();
  }
}
